import React, { useEffect, useState } from 'react';
import { styles } from "./styles";
import {Alert, Grid, IconButton, LinearProgress, Snackbar, Typography} from "@mui/material";
import { Colors } from "assets/colors";
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import TableHeader from "components/TableHeader/TableHeader";
import UserMngtDataTable from "components/DataTable/UserMngtDataTable";
import RoleMngtDataTable from "components/DataTable/RoleMngtDataTable";
import RolesIcon from "assets/icons/Roles.svg";
import { getAllUsers, getAllRoles, getRole } from 'apis/user';
import AddUserModal from "components/UserManagement/AddUserModal/AddUserModal";
import DeleteUserModal from "components/UserManagement/DeleteUserModal/DeleteUserModal";
import DeleteRoleModal from "components/UserManagement/DeleteRoleModal/DeleteRoleModal";
import AddRoleModal from 'components/UserManagement/AddRole/AddRole';
import EditRoleModal from 'components/UserManagement/AddRole/EditRole';
import ToastManager from "../../common/ToastManager";
import DeleteModal from "../../common/DeleteModal";
import CommonUtil from "../../common/CommonUtil";

interface UserManagementProps {
}

const UserManagement: React.FC<UserManagementProps> = () => {
  const [addUser, setAddUser] = useState(false);
  const [deleteUser, setDeleteUser] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [currentTab, setCurrentTab] = useState(0);
  const [data, setData] = useState([]);
  const [userToDelete, setUserToDelete] = useState(null);
  const [roleToDelete, setRoleToDelete] = useState(null);
  const [editUser, setEditUser] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [roleData, setRoleData] = useState([]);
  const [addRole, setAddRole] = useState(false);
  const [deleteRole, setDeleteRole] = useState(false);
  const [roleToEdit, setRoleToEdit] = useState(null);
  const [editRole, setEditRole] = useState(false);
  const [page, setPage] = useState(0);
  const [userDataAfterFilter, setUserDataAfterFilter] = useState([]);
  const [userRoleDataAfterFilter, setUserRoleDataAfterFilter] = useState([]);

  // api call to get list of users and sorts them by lastUpdateDate
  const getUsers = async () => {
    let str = searchVal;
    setIsLoading(true);
    let data = await getAllUsers();
   // console.log(data);
    if (data && data.length > 0) {
      data.forEach((object: any) => {
        if ('creationDate' in object && object.creationDate !== null) {
          const date = new Date(object.creationDate);
          const localTimeString = date.toLocaleString();
          object.creationDate = localTimeString;
         // console.log(object.creationDate)
        }
        if ('lastUpdateDate' in object && object.lastUpdateDate !== null) {
          const date = new Date(object.lastUpdateDate);
          const localTimeString = date.toLocaleString().toString();
          object.lastUpdateDate = localTimeString;
        }
      });
      const sortedArray = data.sort((a: any, b: any) => {
        // Convert the lastUpdateDate strings to Date objects
        const dateA = new Date(a.lastUpdateDate);
        const dateB = new Date(b.lastUpdateDate);
        // Compare the dates and return the result
        if (dateA > dateB) {
          return -1;
        } else if (dateA < dateB) {
          return 1;
        } else {
          return 0;
        }
      });
      setData(sortedArray);
      setIsLoading(false);
      setUserToEdit(null);
      setUserToDelete(null);
      setSearchVal("");
      setTimeout(()=>{
        setSearchVal(str);
        setPage(Math.random()*10000);
      })


      console.log(searchVal,currentTab);
    }
  }

  // api call to get list of roles and sorts them by lastUpdateDate
  const getRoles = async () => {
    let str = searchVal;
    setIsLoading(true);
    let data = await getAllRoles();
    if (data && data.length > 0) {
      data.forEach((object: any) => {
        if ('creationDate' in object && object.creationDate !== null) {
          const date = new Date(object.creationDate);
          const localTimeString = date.toLocaleString();
          object.creationDate = localTimeString;
        }
        if ('lastUpdateDate' in object && object.lastUpdateDate !== null) {
          const date = new Date(object.lastUpdateDate);
          const localTimeString = date.toLocaleString().toString();
          object.lastUpdateDate = localTimeString;
        }
      });
      const sortedArray = data.sort((a: any, b: any) => {
        // Convert the lastUpdateDate strings to Date objects
        const dateA = new Date(a.lastUpdateDate);
        const dateB = new Date(b.lastUpdateDate);

        // Compare the dates and return the result
        if (dateA > dateB) {
          return -1;
        } else if (dateA < dateB) {
          return 1;
        } else {
          return 0;
        }
      });
      setRoleData(sortedArray);
      setIsLoading(false);
      setRoleToEdit(null);
      setRoleToDelete(null);

      setSearchVal("");
      setTimeout(()=>{
        setSearchVal(str);
        setPage(Math.random()*10000);
      })
    }
  }

  // useEffect(() => {
  //   //ToastManager.showToast("Welcome to React Project","Success");
  //   for (var x1 in sessionStorage) {
  //     var obj = sessionStorage[x1];
  //     if (obj) {
  //       //console.log(obj);
  //       try{
  //         var obj1 = JSON.parse(obj);
  //         if (obj1 && obj1.credentialType == "IdToken") {
  //           //console.log(obj1.secret);
  //           //sessionStorage.setItem("appToken", obj1.secret);
  //         }
  //       }catch (err){
  //        // console.log(err);
  //       }
  //     }
  //   }
  //   getUsers();
  //   getRoles();
  // }, []);

  useEffect(() => {
  for (let key in sessionStorage) {
    if (!Object.prototype.hasOwnProperty.call(sessionStorage, key)) continue;

    const rawData = sessionStorage.getItem(key);
    if (!rawData) continue;

    try {
      const parsed = JSON.parse(rawData);
      if (parsed && parsed.credentialType === "IdToken" && typeof parsed.secret === "string") {
        CommonUtil.sessionKey = parsed.secret; // store in memory
        break; // stop once found
      }
    } catch {
      // ignore parse errors
    }
  }
  getUsers();
  getRoles();
}, []);


  useEffect(() => {
    if (!deleteUser) {
      setUserToDelete(null);
    }
  }, [deleteUser]);

  useEffect(() => {
    if (addRole) {
      setRoleToEdit(null);
    }
  }, [addRole]);


  // buttons fed to TableHeader Component
  let tableButtons = [
    {
      label: "Add User",
      onClickHandler: () => setAddUser(true),
      buttonStyle: { backgroundColor: Colors.LightBlue },
      icon: <AddIcon sx={{ marginRight: ".5rem" }} />
    },
  ]
  let roleButtons = [
    {
      label: "Add Role",
      onClickHandler: () => setAddRole(true),
      buttonStyle: { backgroundColor: Colors.Red },
      icon: <AddIcon sx={{ marginRight: ".5rem" }} />
    },
  ]

  let getTabs = ()=>{

  }
  let tabs = [];
  let isUserManagement = false;
  let isRoles = false;
  if(CommonUtil.isScreenAvailable(CommonUtil.USER_MANAGEMENT)){
    isUserManagement = true;
    tabs.push({
      label: "Users",
      onClickHandler: () => setCurrentTab(0),
      buttonStyle: {
        backgroundColor: currentTab === 0 ? Colors.Green : "inherit",
        color: currentTab === 0 ? "white" : Colors.GrayText,
        border: currentTab === 0 ? "none" : `1px solid ${Colors.BorderGray}`
      },
      icon: <AccountCircleOutlinedIcon sx={{ marginRight: ".5rem" }} />
    });
  }
  if(CommonUtil.isScreenAvailable(CommonUtil.ROLES)){
    isRoles = true;
    tabs.push({
      label: "Roles",
      onClickHandler: () => setCurrentTab(1),
      buttonStyle: {
        backgroundColor: currentTab === 1 ? Colors.Green : "inherit",
        color: currentTab === 1 ? "white" : Colors.GrayText,
        border: currentTab === 1 ? "none" : `1px solid ${Colors.BorderGray}`,
        padding: 0,
        marginLeft: '7px'
      },
      icon: <img src={RolesIcon} style={{ marginRight: ".5rem" }} />
    });
  }

  if(!isUserManagement && isRoles){
    tabs[0] = ({
      label: "Roles",
      onClickHandler: () => setCurrentTab(0),
      buttonStyle: {
        backgroundColor: currentTab === 0 ? Colors.Green : "inherit",
        color: currentTab === 0 ? "white" : Colors.GrayText,
        border: currentTab === 0 ? "none" : `1px solid ${Colors.BorderGray}`,
        padding: 0,
        marginLeft: '7px'
      },
      icon: <img src={RolesIcon} style={{ marginRight: ".5rem" }} />
    });

    tableButtons = roleButtons;

    //setData(roleData);
  }
  if(isUserManagement){
    if(!CommonUtil.isScreenButtonAvailable(CommonUtil.USER_MANAGEMENT,CommonUtil.UPDATE_MODE)){
      tableButtons = [];
    }
  }
  if(isRoles){
    if(!CommonUtil.isScreenButtonAvailable(CommonUtil.ROLES,CommonUtil.UPDATE_MODE)){
      roleButtons = [];
      tableButtons= [];
    }
  }

  const handleModalAction = async (val: string, data: any) => {
    if (val === "deleteUser") {
      setDeleteUser(true);
      setUserToDelete(data);
    }
    if (val === "editUser") {
      setEditUser(true);
      setUserToEdit(data);
    }
    if (val === "deleteRole") {
      setDeleteRole(true);
      setRoleToDelete(data);
    }
    if (val === "editRole") {
      try {
        let result = await getRole(data.roleId);
        setRoleToEdit(result);
        setEditRole(true);
      } catch (e) {
        console.log(e)
      }
    }
  }

  let handleDeleteRole = (role:any)=>{
    console.log(role);
  }

      // Downloading Only Filtered Data After Search
      const updateFilteredData = (data:[]) => {
        setUserDataAfterFilter(data);
      }
    // Downloading Only Filtered Data After Search
    const updateFilteredRoleData = (data:[]) => {
      setUserRoleDataAfterFilter(data);
    }

  return (
    <Grid container spacing={2}>

      {isLoading && <LinearProgress sx={{ marginBottom: "1rem" }} />}
      {addUser && <AddUserModal open={addUser} handleClose={setAddUser} getUsers={getUsers} />}
      {editUser && <AddUserModal open={editUser} handleClose={setEditUser} getUsers={getUsers} userToEdit={userToEdit} />}
      {deleteUser && <DeleteUserModal open={deleteUser} handleClose={setDeleteUser} user={userToDelete} getUsers={getUsers} />}
      {/*deleteRole && <DeleteRoleModal open={deleteRole} handleClose={setDeleteRole} role={roleToDelete} getRoles={getRoles} />*/}
      {deleteRole && <DeleteModal title="Delete Role" open={deleteRole} handleDelete={handleDeleteRole} handlePopupClose={setDeleteRole} role={roleToDelete} getList={getRoles} />}
      {editRole && <EditRoleModal open={editRole} handleClose={setEditRole} roleToEdit={roleToEdit} getRoles={getRoles} />}
      {addRole && <AddRoleModal open={addRole} handleClose={setAddRole} getRoles={getRoles} />}
      <TableHeader
        actionButtons={currentTab === 0 ? tableButtons : roleButtons}
        searchVal={searchVal} setSearchVal={setSearchVal}
        data={currentTab === 0 ? userDataAfterFilter : userRoleDataAfterFilter}
        tabs={tabs}
        csvLabel={currentTab === 0 ? "users.csv" : "roles.csv"}
      />
      <Grid item xs={12} sx={{ height: "80vh", width: "80vw" }}>
        {currentTab === 0 && <UserMngtDataTable data={!isUserManagement?roleData:data} searchVal={searchVal} openModal={handleModalAction} getFilteredData={updateFilteredData} />}
        {currentTab === 1 && <RoleMngtDataTable data={roleData} searchVal={searchVal} openModal={handleModalAction} getFilteredData={updateFilteredRoleData} />}
      </Grid>
    </Grid>
  )
}

export default UserManagement;
